import styled from '@emotion/styled';
import { mediaQuery, breakpoints, gutterSizes, fontSizes, colorVariables, colors, fontWeights } from '@gumtree/ui-library/src/base/theme'; // 假设路径正确

export const OverviewWrapper = styled.div`
    width: 100%;
    padding: 20px 0 40px;
    background-color: ${colorVariables.backgroundNeutral};
    border-bottom: 1px solid ${colors.newBorder};

    &::-webkit-scrollbar {
      display: none;
    }

    &::-webkit-scrollbar-track {
        display: none;
    }
`;

export const OverviewTitle = styled.h2`
    margin-bottom: 0;
    color: ${colorVariables.textPrimary};

    font-weight: 600;
    font-size: ${fontSizes.xlarge};
    line-height: 32px;

    ${mediaQuery.from(breakpoints.large)} {
        font-size: ${fontSizes.pgLarge};
    }
`;

export const OverviewList = styled.ul`
  list-style: none;
  padding: 16px 0 0;
  margin: 0;
  display: grid;
  row-gap: ${gutterSizes.medium};
  column-gap: 30px;

  ${mediaQuery.from(breakpoints.medium)} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${mediaQuery.until(breakpoints.medium)} {
    grid-template-columns: 1fr;
  }
`;

export const OverviewListItem = styled.li`
  display: flex;
  align-items: center;
  font-size: ${fontSizes.base};
  color: ${colorVariables.textPrimary};

  .icon {
    margin-right: ${gutterSizes.small};
    color: ${colorVariables.textPrimary};
    display: inline-flex;
    align-items: center;
  }

  .second-icon {
    margin-left: ${gutterSizes.small};
  }

  .label {
    margin-right: ${gutterSizes.base};
  }

  .value {
    font-weight: ${fontWeights.bold};
    color: ${colorVariables.textPrimary};
  }

  a {
    font-size: ${fontSizes.base};
    font-weight: ${fontWeights.bold};
    color: ${colors.navy};
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const MapText = styled.div`
    font-size: ${fontSizes.base};
    font-weight: ${fontWeights.bold};
    color: ${colors.navy};
    text-decoration: underline;
    cursor: pointer;
`;
